// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"080c89f4f0d165fc","9990":"dbcc2e32058a79ce"}[chunkId] + ".css";
};